import { uuid } from "@/interfaces";
import { activeOrganizationIdIfAny } from "@/lib/active-organization";
import { api } from "@/lib/api";
import { DailyWorkExecution } from "@/models/daily-work.model.ts";
import { requirePermission } from "@/lib/permissions";
import { clockRecordsOf } from "./work-day-records";

export interface DailyWorkExecutionJoin extends Omit<DailyWorkExecution, "daily_work_day"> {
  daily_work_day: {
    id: uuid;
    work_date: string;
    tasks: string[];
    service: {
      id: uuid;
      name: string;
      parent_name: string;
    };
    assigned_user: {
      id: uuid | null;
      name: string | null;
    } | null;
    assigned_org: {
      id: uuid | null;
      display_name: string | null;
    } | null;
  } | null;
}

export const DailyWorkExecutionRepository = {
  async listByDay(dailyWorkDayId: uuid): Promise<DailyWorkExecutionJoin[]> {
    await requirePermission("daily_work.view");

    return clockRecordsOf(await api.workDays.get(dailyWorkDayId, { actingOrganization: activeOrganizationIdIfAny() }));
  },
};

